import { render, staticRenderFns } from "./ApplyChannel.vue?vue&type=template&id=11044591&scoped=true"
import script from "./ApplyChannel.vue?vue&type=script&lang=js"
export * from "./ApplyChannel.vue?vue&type=script&lang=js"
import style0 from "./ApplyChannel.vue?vue&type=style&index=0&id=11044591&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11044591",
  null
  
)

export default component.exports